const handleClick = (event: Event) => {
  event.preventDefault();

  const anchor = event.target as HTMLAnchorElement;
  window.open(anchor.href, "_blank");
};

export const setOpenExternLinkHandlers = () => {
  document.querySelectorAll("a.externLink").forEach((link) => {
    link.removeEventListener("click", handleClick);
    link.addEventListener("click", handleClick);
  });
};
